import React, { useContext, useEffect } from 'react';
import ReportList from './reportsBase';
import { TemplateContext } from '../../pagesMains/GravesManagers/Graves';
import { GlobalContext } from '../../../../App';

const ReportsDashboard = () => {
  const { setTotalWidthContainer } = useContext(TemplateContext)
  const { setTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`דוחות`)
  }, []);



  const reports = [
    {
      name: 'סטטוס מכירות ורכישות',
      description: 'מציג כמות קברים שנרכשו ו/או נקברו לפי תקופה, ופירוט סוג הקבורה',
      route: '/GraveStatusReport',
    },
    {
      name: 'GraveDetailReport',
      description: 'GraveDetailReport',
      route: '/GraveDetailReport',
    },
    {
      name: 'print',
      description: 'מציג כמות קברים שנרכשו ו/או נקברו לפי תקופה, ופירוט סוג הקבורה',
      route: '/PrintReport',
    },
    {
      name: 'דוח מלאי',
      description: 'דוח המציג מצב מלאי נוכחי',
      route: '/inventory-report',
    },
    {
      name: 'דוח לקוחות',
      description: 'דוח המציג נתוני לקוחות',
      route: '/customer-report',
    },
  ];

  return (
    <div>
      <h1>רשימת דוחות</h1>
      <ReportList reports={reports} />
    </div>
  );
};

export default ReportsDashboard;
